import React, { useEffect } from 'react';
import { Grid, makeStyles, Typography } from 'housecall-ui';

import { trackPage } from '../../src/hooks/useEventTracking';
import success from '../assets/success.svg';
import { Footer } from '../components/Footer';

const IMAGE_SIZE = 96;
const MIN_HEIGHT = 530;

const useStyles = makeStyles((theme) => ({
  page: {
    height: '100%',
    width: '100%',
    minHeight: MIN_HEIGHT,
  },
  container: {
    padding: theme.spacing(4),
    height: '100%',
  },
}));

export const SuccessPage = () => {
  const { container, page } = useStyles();

  useEffect(() => {
    trackPage('Lead form success');
  }, []);

  return (
    <Grid container alignContent="center" className={page}>
      <Grid container alignContent="center" className={container}>
        <Grid item xs={12}>
          <Grid container alignItems="center" direction="column" spacing={2}>
            <Grid item>
              <img src={success} alt="success" width={IMAGE_SIZE} height={IMAGE_SIZE} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" align="center">
            Thank you for contacting us.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" align="center" gutterBottom>
            Our team is reviewing your information and will contact you shortly.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Footer />
        </Grid>
      </Grid>
    </Grid>
  );
};
